import { Component, input } from '@angular/core';
import { provideIcons } from '@ng-icons/core';
import { lucideCircleAlert, lucideX } from '@ng-icons/lucide';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmIconImports } from '@spartan-ng/helm/icon';
import { toast } from 'ngx-sonner';

import { ToastrModel } from './toastr.model';

@Component({
  selector: 'app-toastr-error',
  imports: [HlmIconImports, HlmButtonImports],
  providers: [provideIcons({ lucideCircleAlert, lucideX })],
  templateUrl: './toastr.component.html',
})
export class ToastrErrorComponent implements ToastrModel {
  readonly titre = input<string>('Erreur');
  readonly message = input.required<string>();
  readonly icone = 'lucideCircleAlert';
  readonly bgClass = 'bg-feedback-negative-lightest';
  readonly iconClass = 'text-feedback-negative-darker';

  readonly id = input.required<string>();

  closeToastr = () => toast.dismiss(this.id());
}
